import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Navbar from "./Components/NavBar";
import HomePage from "./Pages/HomePage";
import Footer from "./Components/HomePageComponents/Footer";
import AboutUs from "./Pages/AboutUs";
import Services from "./Pages/ServicesPage";
import ContactUs from "./Pages/ContactUs";
import IEBCHighlights from "./Pages/EventsAndNewPage";

const NotFoundPage = () => (
  <div className="p-4 text-red-600 bg-red-50 rounded-md">
    <h1 className="text-2xl font-bold">404 - Page Not Found</h1>
    <p className="mt-2">The page you are looking for does not exist.</p>
  </div>
);

const App = () => {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-100 flex flex-col">
        {/* Header and Navigation */}
        <header className="bg-blue-600 text-white shadow-md">
          <Navbar />
        </header>

        {/* Main content area where routes will render */}
        <main className="pt-[10vh]">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/news-events" element={<IEBCHighlights />} />

            <Route path="/contact" element={<ContactUs />} />
            {/* Catch-all route for any undefined paths */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </BrowserRouter>
  );
};

export default App;
